module.exports = __webpack_public_path__ + "static/media/honor1.fea96cfe.png";